import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import type { ImageAsset } from '../../types/content';
import { ImageSlot } from './ImageSlot';
interface PageHeroProps {
  title: React.ReactNode;
  sub?: React.ReactNode;
  image: ImageAsset;
  crumbs?: {
    label: string;
    to?: string;
  }[];
  badge?: string;
  children?: React.ReactNode;
}
export function PageHero({
  title,
  sub,
  image,
  crumbs,
  badge,
  children
}: PageHeroProps) {
  return <section className="under-header relative isolate overflow-hidden bg-ink" data-id="element-548" data-mp="17dr9mg1cb212">
      <ImageSlot image={image} eager decorative className="absolute inset-0 -z-10 opacity-60" imgClassName="ken-burns" data-id="element-549" data-mp="17bn9882ngl5j" />
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-ink via-ink/85 to-midnight/40" aria-hidden="true" data-id="element-550" data-mp="xfk4qvkbsaff" />
      <div className="absolute inset-x-0 bottom-0 -z-10 h-1/2 bg-gradient-to-t from-ink to-transparent" aria-hidden="true" data-id="element-551" data-mp="3n4vvnep4f6fc" />
      <div className="gutter pb-[clamp(3.5rem,7vw,7rem)] pt-[clamp(3rem,7vw,7rem)]" data-id="element-552" data-mp="3i3zjkdum8dyu">
        {crumbs && <nav aria-label="Breadcrumb" className="mb-6" data-id="element-553" data-mp="2t4rxjr1cxce7">
            <ol className="flex flex-wrap items-center gap-1.5 text-sm text-chrome-300" data-id="element-554" data-mp="2y3d03x43085t">
              <li data-id="element-555" data-mp="2j6c59kqlfx34">
                <Link to="/" className="hover:text-white" data-id="element-556" data-mp="2j4sq5xgobs2x">
                  Home
                </Link>
              </li>
              {crumbs.map(c => <li key={c.label} className="flex items-center gap-1.5" data-id="element-557" data-mp="2adiplm78ivoq">
                  <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-558" data-mp="2ac7h592ugzra" />
                  {c.to ? <Link to={c.to} className="hover:text-white" data-id="element-559" data-mp="2f621meq9xirf">
                      {c.label}
                    </Link> : <span aria-current="page" className="text-white" data-id="element-560" data-mp="25fh5cxy2oqbo">
                      {c.label}
                    </span>}
                </li>)}
            </ol>
          </nav>}
        {badge && <span className="mb-5 inline-block rounded-[3px] bg-accent px-3 py-1 font-display text-sm font-semibold tracking-[0.12em] text-white" data-id="element-561" data-mp="1vicjz0c1wyvx">
            {badge}
          </span>}
        <h1 className="t-display max-w-[18ch] text-[clamp(2.5rem,5.5vw,7rem)] text-white" data-id="element-562" data-mp="3ta3tgzpm20na">{title}</h1>
        <span className="red-rule mt-6" aria-hidden="true" data-id="element-563" data-mp="3ob0zqbf2zgum" />
        {sub && <p className="t-lead mt-6 max-w-[52rem] text-chrome-300" data-id="element-564" data-mp="3jfbv3to7f9rg">{sub}</p>}
        {children && <div className="mt-8 flex flex-wrap gap-3" data-id="element-565" data-mp="kvc03npkl24b">{children}</div>}
      </div>
    </section>;
}